/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import SiteNav from './site-nav'
import site from '../constants/site'

import "./layout.css"

const Layout = ({ children, location }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  if(typeof window === 'undefined') return null

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} pathname={location.pathname} />
      <div id="site-content">
        <div id="site-titles">
          <Link to = "/"><h1>{site.title}:</h1></Link>
          <Link to = "/"><h2> {site.subtitle}</h2></Link>
        </div>
        {console.log('FROM LAYOUT: ', location.pathname)}
        <SiteNav pathname={location.pathname} />
        <div id="page-container">
          <main>{children}</main>
        </div>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
